import Vue from 'vue'
import qs from 'querystring'

export const ApplicationList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list?p=${params.p || 1}&c=${params.c || 12}`, params)
}

export const TaizhouApplicationList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list/taizhou?p=${params.p || 1}&c=${params.c || 12}`, params)
}

export const ApplicationDetail = function (params) {
  return Vue.prototype.$axios.post('/shop/apply/detail', params)
}

export const OfficialList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/official/excellent?${qs.stringify(params)}`)
}

export const NewestList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/newest?${qs.stringify(params)}`)
}

export const LikeList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/like?${qs.stringify(params)}`)
}

export const MyAppList = function (params) {
  return Vue.prototype.$axios.post('/shop/tag', params)
}

export const SolutionList = function (params) {
  return Vue.prototype.$axios.post(`shop/solution/list?p=${params.p || 1}&c=${params.c || 6}`, params)
}

export const GetHuangYanList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/tag/list/huangyan`, params)
}

export const GetYiWuList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/tag/list/yiwu`, params)
}
export const GetHaiShuList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/tag/list/haishu`, params)
}
export const YiWuApplicationList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list/yiwu?p=${params.p || 1}&c=${params.c || 12}`, params)
}
export const HaiShuApplicationList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list/haishu?p=${params.p || 1}&c=${params.c || 12}`, params)
}
export const HuangYanApplicationList = function (params) {
  return Vue.prototype.$axios.post(`/shop/apply/list/huangyan?p=${params.p || 1}&c=${params.c || 12}`, params)
}



// WEBPACK FOOTER //
// ./src/services/application.js